import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	create: {
		defaultMessage: 'Create',
		id: 'atlassian-navigation.create.create',
		description: 'Create a new issue',
	},
	createButtonAriaLabel: {
		defaultMessage: 'Create issue',
		id: 'atlassian-navigation.create.create-button-aria-label',
		description: 'Create a new issue button aria-label text',
	},
	createButtonAriaLabelIssueTermRefresh: {
		defaultMessage: 'Create',
		id: 'atlassian-navigation.create.create-button-aria-label-issue-term-refresh',
		description: 'Create a new issue button aria-label text',
	},
});
